export interface AppFileInfo {
  path: string
  mimeType: string
  size: number
  metadata?: Record<string, string>
}

export interface AppSettingSetDefinition {
  key: string
  label?: Record<string, string>
  description?: Record<string, string>
  order?: number
}

export interface AppSettingEditorHints {
  type?: string
  order?: number
  set?: string | AppSettingSetDefinition
  [key: string]: unknown
}


export interface AppSettingDefinitionInfo {
  label: Record<string, string>
  description?: Record<string, string>
  secret: boolean
  editor?: AppSettingEditorHints
}


export type AppRuntimeState = "starting" | "running" | "broken"

export type BrokenDiagnosticKind = "moduleType" | "graphShape" | "internal"

export interface BrokenDiagnostic {
  path: string
  message: string
  kind: BrokenDiagnosticKind
  detectedAt: string
}

export type AppRequiresGraphEdgeCardinality = "single" | "many"

export interface AppRequiresGraphField {
  type: string
  dimension?: string
  enumDefinition?: string
}

export interface AppRequiresGraphEdge {
  cardinality: AppRequiresGraphEdgeCardinality
  relatedNode: string
}

export interface AppRequiresGraphNode {
  fields: Record<string, AppRequiresGraphField>
  edges: Record<string, AppRequiresGraphEdge>
}

export interface AppRequiresGraphSet {
  node: string
}

export interface AppRequiresGraph {
  nodes: Record<string, AppRequiresGraphNode>
  sets: Record<string, AppRequiresGraphSet>
}

export interface AppRequiresModuleExport {
  type: string
}

export interface AppRequiresModule {
  exports: Record<string, AppRequiresModuleExport>
}

export interface AppRequires {
  graph?: AppRequiresGraph
  modules: Record<string, AppRequiresModule>
}

export interface AppProvidesRegistryEntryInfo {
  path: string
  /**
   * The registry value as a JSON-encoded string, exactly as stored.
   */
  value: string
}

export interface AppProvides {
  registryEntries: AppProvidesRegistryEntryInfo[]
}

export interface AppInfo {
  id: string
  name: string
  description?: string
  authors: string[]
  currentVersion?: string
  installedVersions: string[]
  files: AppFileInfo[]
  settingDefinitions: Record<string, AppSettingDefinitionInfo>
  requires?: AppRequires
  provides: AppProvides
  runtimeState?: AppRuntimeState
  diagnostics: BrokenDiagnostic[]
}

export type AppSettingsValues = Record<string, unknown>

export class AppsApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message?: string
  ) {
    super(message || code)
    this.name = 'AppsApiError'
  }
}
